

export const Region = {
  async init(){
    const screen_PCs = document.querySelectorAll('#screen_pc');
    if(screen_PCs.length == 0)return;
    console.log('Region.js loaded!');



    for (const screen_PC of screen_PCs) {
      const area = screen_PC.querySelector('.area');
      const title = area.innerText;
      const length = await this.getStringLength(title);
      const fontSize = await this.getFontSize(area);
      console.log(length,fontSize);
      const newFontSize = await this.calculateFontSize(length, fontSize);
      console.log(newFontSize);
      await this.setFontSize(area, newFontSize);
    }

  },
  // 適切な文字サイズを計算する関数
  async calculateFontSize(length, fontSize) {
    let newFontSize = fontSize;
    console.log(length,fontSize);
    // もし全角2文字
    if (length == 4) {
      newFontSize = fontSize * 1.1;
    }

    // もし全角4文字
    if (length == 8) {
      newFontSize = fontSize * 0.85;
    }
    // もし全角4文字
    if (length == 14) {
      newFontSize = fontSize * 0.72;
    }
    return newFontSize;
  },


  // 文字列の文字数を返す関数
  async getStringLength(str) {
    let length = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charAt(i);
      if (char.match(/[^\x01-\x7E]/)) {
        length += 2; // 全角文字は2文字分としてカウント
      } else {
        length += 1; // 半角文字は1文字分としてカウント
      }
    }
    return length;
  },
  // 要素に適用されているcomputed styleを取得する関数
  async getFontSize(element) {
    const computedStyle = window.getComputedStyle(element);
    const fontSize = computedStyle.fontSize;
    return parseFloat(fontSize);
  },
  // 要素にフォントサイズを適用する関数
  async setFontSize(element, fontSize) {
    // fontSizeが数値の場合はそのまま、pxの場合は数値に変換
    if (typeof fontSize === 'string') {
      fontSize = parseFloat(fontSize);
    }
    element.style.fontSize = fontSize + 'px';
  },


}